function useScrollGroup(_groupPath) {
}
export {
  useScrollGroup
};
//# sourceMappingURL=useScrollGroup.native.js.map
